var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [
        { name: "drag", rawName: "v-drag" },
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        visible: _vm.dialogVisible,
        width: "1200px",
        "show-close": true,
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
        _vm._v(" 发送美国 "),
        _vm.rowData.sendSupplierOn
          ? _c("span", { staticClass: "tips" }, [_vm._v(" 多次发送 ")])
          : _vm._e(),
      ]),
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          { staticStyle: { width: "49%" } },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "form",
                attrs: {
                  model: _vm.form,
                  rules: _vm.rules,
                  "label-position": "top",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "clearenceCode", label: "清关行" } },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "calc(100% - 110px)" },
                            attrs: {
                              placeholder: "请选择",
                              disabled: _vm.rowData.sendSupplierOn,
                            },
                            on: { change: _vm.change },
                            model: {
                              value: _vm.form.clearenceCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "clearenceCode", $$v)
                              },
                              expression: "form.clearenceCode",
                            },
                          },
                          _vm._l(_vm.options, function (item) {
                            return _c("el-option", {
                              key: item.code,
                              attrs: { label: item.code, value: item.code },
                            })
                          }),
                          1
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "12px" },
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                _vm.dialogVisible1 = true
                              },
                            },
                          },
                          [_vm._v("管理清关行")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "Email To", prop: "receiver" } },
                  [
                    _c("el-input", {
                      attrs: { disabled: "", placeholder: "请输入收件人" },
                      model: {
                        value: _vm.form.receiver,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "receiver", $$v)
                        },
                        expression: "form.receiver",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "Cc", prop: "cc" } },
                  [
                    _c("el-input", {
                      attrs: { disabled: "", placeholder: "请输入抄送人" },
                      model: {
                        value: _vm.form.cc,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "cc", $$v)
                        },
                        expression: "form.cc",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "主题", prop: "subject" } },
                  [
                    _c("el-input", {
                      attrs: {
                        disabled: _vm.rowData.sendSupplierOn,
                        type: "textarea",
                        placeholder: "请输入主题",
                      },
                      model: {
                        value: _vm.form.subject,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "subject", $$v)
                        },
                        expression: "form.subject",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "正文", prop: "content" } },
                  [
                    _c("vue-editor", {
                      ref: "editor",
                      model: {
                        value: _vm.form.content,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "content", $$v)
                        },
                        expression: "form.content",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticStyle: { width: "49%" } },
          [
            _c("BaseTable", {
              attrs: {
                height: 728,
                tableData: _vm.tableData,
                isPager: false,
                loading: false,
              },
              on: { handleSelectionChange: _vm.handleSelectionChange },
              scopedSlots: _vm._u([
                {
                  key: "opt",
                  fn: function (row) {
                    return _c("div", { staticClass: "optbtn" }, [
                      _c(
                        "div",
                        {
                          staticClass: "btn",
                          attrs: { title: "查看" },
                          on: {
                            click: function ($event) {
                              return _vm.check(row.scope)
                            },
                          },
                        },
                        [_c("i", { staticClass: "el-icon-zoom-in" })]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "btn",
                          attrs: { title: "下载" },
                          on: {
                            click: function ($event) {
                              return _vm.download(row.scope)
                            },
                          },
                        },
                        [_c("i", { staticClass: "el-icon-download" })]
                      ),
                    ])
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取 消")]
          ),
          _c(
            "div",
            {
              staticClass: "ok flex_c_c",
              on: {
                click: function ($event) {
                  return _vm.ok("form")
                },
              },
            },
            [_vm._v("确 定")]
          ),
        ]
      ),
      _c("ClearenceTplDialog", {
        attrs: { dialogVisible: _vm.dialogVisible1, options: _vm.options },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible1 = false
          },
          ok: function ($event) {
            _vm.getList()
            _vm.dialogVisible1 = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }